import { useLanguage } from "../i18n";

const ITEMS = [
  "Siti web professionali",
  "Redesign siti web",
  "Presenza digitale",
  "Design su misura",
  "Esperienza utente",
  "Recensioni NFC",
];

export const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div
      className="overflow-hidden border-y border-salvia/30 bg-acqua/50 py-4"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-10">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-sm font-semibold uppercase tracking-[0.28em] text-petrolio/80">
              {t(item)}
            </span>
            <svg viewBox="0 0 8 8" className="h-2 w-2 fill-salvia">
              <circle cx="4" cy="4" r="4" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};
